// This file is auto-generated. Run `pnpm generate:icons` to regenerate.
// biome-ignore-all assist/source/organizeImports: Generated file.
// biome-ignore-all format: Generated file.
// biome-ignore-all lint/a11y/noSvgWithoutTitle: Icon accessibility is handled by the Icon wrapper.
import type { SVGProps } from "react";

export default function ChevronDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z" fill="currentColor" />
</svg>
  );
}